import React, { useCallback } from 'react';
import { AppRemixIcon } from '@/layout/AppComponents';
import styled from 'styled-components';
import colors from '../../../../../constants/colors';

export default function ObligationManageCard({
  resourceObligation = null,
  obligation = null,
  obligationsToRemove = null,
  setObligationsToRemove = null,
  obligationsToAdd = null,
  setObligationsToAdd = null,
  add = false,
}) {
  const handleClickCheckboxRemove = useCallback(() => {
    if (obligationsToRemove.includes(resourceObligation.id)) {
      setObligationsToRemove(
        obligationsToRemove.filter((id) => id !== resourceObligation.id)
      );
    } else {
      setObligationsToRemove([...obligationsToRemove, resourceObligation.id]);
    }
  }, [obligationsToRemove, resourceObligation]);

  const handleClickCheckboxAdd = useCallback(() => {
    if (obligationsToAdd.includes(obligation.id)) {
      setObligationsToAdd(
        obligationsToAdd.filter((id) => id !== obligation.id)
      );
    } else {
      setObligationsToAdd([...obligationsToAdd, obligation.id]);
    }
  }, [obligationsToAdd, obligation]);

  if (add) {
    return (
      <>
        <Card className="list-group-item p-0">
          <div className="rs-check" onClick={() => handleClickCheckboxAdd()}>
            <AppRemixIcon
              icon={
                obligationsToAdd.includes(obligation.id)
                  ? 'checkbox'
                  : 'checkbox-blank'
              }
              size={20}
            />
          </div>

          <div
            className="rs-obligationText"
            dangerouslySetInnerHTML={{
              __html: obligation?.obligation,
            }}
          />
        </Card>
      </>
    );
  }
  return (
    <>
      <Card className="list-group-item p-0">
        {resourceObligation?.state === -1 ? (
          <div className="rs-check" onClick={() => handleClickCheckboxRemove()}>
            <AppRemixIcon
              icon={
                obligationsToRemove.includes(resourceObligation.id)
                  ? 'checkbox'
                  : 'checkbox-blank'
              }
              size={20}
            />
          </div>
        ) : (
          <div className="rs-check">
            <AppRemixIcon
              icon="checkbox-blank"
              size={20}
              color={colors.grey400}
            />
          </div>
        )}

        <div
          className="rs-obligationText"
          dangerouslySetInnerHTML={{
            __html: resourceObligation?.obligation?.obligation,
          }}
        />
      </Card>
    </>
  );
}

const Card = styled.div`
  display: grid;
  grid-template-columns: 60px 1fr;
  gap: 10px;
  height: 60px;
  overflow-y: scroll;
  .rs-check {
    display: flex;
    max-height: 60px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-right: 1px solid #ccc;
  }
  .rs-obligationText {
    overflow-y: scroll;
  }
`;
